import Vue from 'vue';
import dayjs from 'dayjs';

/**
 * URL without protocol
 */
Vue.filter('url_without_protocol', (value) => {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }
  return value.replace(/^(https?:\/\/)/, '');
});

/**
 * Phone number formatter
 */
Vue.filter('phone', (value) => {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }
  return value.replace(/^(\d{3})(\d{3})(\d+)$/, '$1-$2-$3');
});

/**
 * To uppercase
 */
Vue.filter('upper', (value) => {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }
  return value.toUpperCase();
});

/**
 * To lowercase
 */
Vue.filter('lower', (value) => {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }
  return value.toLowerCase();
});

Vue.filter('trim', (value) => {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }
  return value.trim();
});

/**
 * Currency formatter
 */
Vue.filter('currency', (amount, roundDigits = 0) => {
  if (typeof amount === 'undefined' || amount === null || amount === '') {
    return '';
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: roundDigits,
    maximumFractionDigits: roundDigits,
  });
  return formatter.format(amount);
});

Vue.filter('dateFormat', (value) => {
  if (!value) {
    return '';
  }
  return dayjs(value).format('MM/DD/YYYY');
});

/**
 * Return full path for logo image
 */
Vue.filter('logo', (logoFilename) => (logoFilename
  ? `${process.env.VUE_APP_SERVER_BASE_URI}/upload/logo/${logoFilename}`
  : `${process.env.VUE_APP_SERVER_BASE_URI}/upload/logo/no-logo.png`));
